export const environment = {
  production: false,
  ministry: 'ក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ',
  baseUrl: '',
  baseUrl_ocr: '',
  default_doc_type_id: '5be39bddb7eb68078652121f', 
  default_from_to_id: '5ea0ff5a0086940a8cab377c',
  scanner_key: '',
  cabinet_group_id: '60657b1d50a180436c0812ff',
  firebase: {
    apiKey: "AIzaSyBtvdWpFQAG_c9Iq86VKV8dCtZGKhhe11A",
    authDomain: "mef-edocs-pro.firebaseapp.com",
    databaseURL: "https://mef-edocs-pro-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "mef-edocs-pro",
    storageBucket: "mef-edocs-pro.firebasestorage.app",
    messagingSenderId: "533906487163",
    appId: "1:533906487163:web:87cdd14a2ea4856d0f2fde",
    measurementId: "G-NM3P947C8E"
  },
  bridge_scanner_core_version_stable: {
    version: "",
    url:""
  }
};